module.exports = __webpack_public_path__ + "static/media/edit_icon.2a27454b.svg";